import * as Sentry from '@sentry/vue'

const FLUSH_MS = 1500

/**
 * Emits a searchable Sentry event + breadcrumb, flushes the client, then reloads the WebView
 * after a native watchdog timeout (UI stuck / no ping).
 */
export function performWatchdogRecoveryReload(): void {
  try {
    Sentry.addBreadcrumb({
      category: 'player_watchdog_recovery',
      message: 'reload',
      level: 'warning',
      data: { reason: 'watchdog_timeout' }
    })
    Sentry.captureMessage('Player watchdog recovery reload', {
      level: 'warning',
      tags: {
        player_watchdog_recovery_reload: 'true'
      },
      fingerprint: ['player-watchdog-recovery-reload'],
      extra: { reason: 'watchdog_timeout' }
    })
  }
  catch {
    /* Sentry unavailable */
  }

  const reload = () => {
    window.location.reload()
  }

  try {
    void Sentry.flush(FLUSH_MS).then(reload, reload)
  }
  catch {
    reload()
  }
}
